var isValidAmount = function (value) {
    var validAmountRegex = /^\d{0,5}(\.\d{0,2})?$/;
    return validAmountRegex.test(value);
};
export default isValidAmount;
//# sourceMappingURL=isValidAmount.js.map